module.exports = __webpack_public_path__ + "static/media/smallClose.fcc52ae2.svg";